import { css } from 'styled-components'
import tw from 'twin.macro'

export const fileUploaderFieldContainerStyles = css`
  ${tw`mb-3`};
  @media (max-width: 1023px) {
    ${tw`mb-1`};
  }
`
